import { Outlet } from "react-router-dom";
import { PageHeader } from "@/components/ui/PageHeader";
import { Tabs, type TabItem } from "@/components/ui/Tabs";
import { useIsAdmin } from "@/hooks/useCurrentUser";

export function SettingsLayout() {
  const isAdmin = useIsAdmin();
  const tabs: TabItem[] = [
    { to: "/settings/profile", label: "Profile" },
    ...(isAdmin
      ? [
          { to: "/settings/organization", label: "Organization" },
          { to: "/settings/plan", label: "Plan" },
        ]
      : []),
  ];

  return (
    <div>
      <PageHeader title="Settings" description="Account, team, and billing preferences." />
      <Tabs items={tabs} />
      <div className="px-4 py-4 sm:px-8 sm:py-6">
        <Outlet />
      </div>
    </div>
  );
}
